import { request } from './request';

export async function appBinaryDownload(
  id: string,
  type: string
): Promise<any> {
  return request('GET', `/convert/app/binaries/${id}/download?type=${type}`);
}
